/* tslint:disable */
/* eslint-disable */
/**
 * ReD Admin API Spec
 * ReD中途企業向けサイト用API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: info@redesigner.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { GetAccount200ResponseFeatureFlagsIntention } from './GetAccount200ResponseFeatureFlagsIntention';
import {
    GetAccount200ResponseFeatureFlagsIntentionFromJSON,
    GetAccount200ResponseFeatureFlagsIntentionFromJSONTyped,
    GetAccount200ResponseFeatureFlagsIntentionToJSON,
} from './GetAccount200ResponseFeatureFlagsIntention';
import type { GetAccount200ResponseFeatureFlagsScoutFree } from './GetAccount200ResponseFeatureFlagsScoutFree';
import {
    GetAccount200ResponseFeatureFlagsScoutFreeFromJSON,
    GetAccount200ResponseFeatureFlagsScoutFreeFromJSONTyped,
    GetAccount200ResponseFeatureFlagsScoutFreeToJSON,
} from './GetAccount200ResponseFeatureFlagsScoutFree';

/**
 * 企業単位の機能フラグ
 * @export
 * @interface GetAccount200ResponseFeatureFlags
 */
export interface GetAccount200ResponseFeatureFlags {
    /**
     * 
     * @type {GetAccount200ResponseFeatureFlagsIntention}
     * @memberof GetAccount200ResponseFeatureFlags
     */
    intention: GetAccount200ResponseFeatureFlagsIntention;
    /**
     * 課題AI機能フラグ。課題AIに登録されている（課題が1件以上ある）企業の場合にtrue
     * @type {boolean}
     * @memberof GetAccount200ResponseFeatureFlags
     */
    designChallengeWithAi202608: boolean;
    /**
     * 
     * @type {GetAccount200ResponseFeatureFlagsScoutFree}
     * @memberof GetAccount200ResponseFeatureFlags
     */
    scoutFree: GetAccount200ResponseFeatureFlagsScoutFree;
}

/**
 * Check if a given object implements the GetAccount200ResponseFeatureFlags interface.
 */
export function instanceOfGetAccount200ResponseFeatureFlags(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "intention" in value;
    isInstance = isInstance && "designChallengeWithAi202608" in value;
    isInstance = isInstance && "scoutFree" in value;

    return isInstance;
}

export function GetAccount200ResponseFeatureFlagsFromJSON(json: any): GetAccount200ResponseFeatureFlags {
    return GetAccount200ResponseFeatureFlagsFromJSONTyped(json, false);
}

export function GetAccount200ResponseFeatureFlagsFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetAccount200ResponseFeatureFlags {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'intention': GetAccount200ResponseFeatureFlagsIntentionFromJSON(json['intention']),
        'designChallengeWithAi202608': json['design_challenge_with_ai_202608'],
        'scoutFree': GetAccount200ResponseFeatureFlagsScoutFreeFromJSON(json['scout_free']),
    };
}

export function GetAccount200ResponseFeatureFlagsToJSON(value?: GetAccount200ResponseFeatureFlags | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'intention': GetAccount200ResponseFeatureFlagsIntentionToJSON(value.intention),
        'design_challenge_with_ai_202608': value.designChallengeWithAi202608,
        'scout_free': GetAccount200ResponseFeatureFlagsScoutFreeToJSON(value.scoutFree),
    };
}

